import { render } from "./WCHomePage.vue?vue&type=template&id=7c02a677"
import script from "./WCHomePage.vue?vue&type=script&lang=js"
export * from "./WCHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__